import { useEffect, useState } from "react";

/** A number that rolls from `from` to `to` (the rating counter, §8.5). */
export function RollingNumber({ from, to, ms = 700 }: { from: number; to: number; ms?: number }) {
  const [value, setValue] = useState(from);
  useEffect(() => {
    if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) {
      setValue(to);
      return;
    }
    let raf = 0;
    const start = performance.now();
    const step = (now: number) => {
      const k = Math.min(1, (now - start) / ms);
      const eased = 1 - Math.pow(1 - k, 3);
      setValue(Math.round(from + (to - from) * eased));
      if (k < 1) raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [from, to, ms]);
  return <span className="num">{value}</span>;
}
